import React, { useEffect, useState, useRef } from "react";
import { getTechnologies } from "../api/technologyService";
import { sleep } from "../utils/sleep"
import * as FaIcons from 'react-icons/fa';
import * as SiIcons from 'react-icons/si';
import * as VscIcons from "react-icons/vsc";


const TechStack = () => {
  const sliderRef = useRef(null);
const [technologies, setTechnologies] = useState([]);
        const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    if (technologies.length === 0) return; // only run when data exists
    const slider = sliderRef.current;
    let scrollAmount = 0;

    const autoScroll = setInterval(() => {
      if (slider) {
        scrollAmount += 1;
        slider.scrollLeft = scrollAmount;

        // Loop back when end is reached
        if (scrollAmount >= slider.scrollWidth - slider.clientWidth) {
          scrollAmount = 0;
        }
      }
    }, 10); // adjust speed (lower = faster)

    return () => clearInterval(autoScroll);
  }, [technologies]);// depend on technologies


  useEffect(() => {
            const fetchTechnologies = async () => {
              try {
                // simulate network delay (3 sec)
                //await sleep(3000);
        
                const data = await getTechnologies(); // asynchronous call
                setTechnologies(data);
              } catch (err) {
                setError("Failed to load technologies.");
              } finally {
                setLoading(false);
              }
            };
        
            fetchTechnologies();
            }, []);
          
          // Loading Overlay
          if (loading) {
            return (
              <div className="loading-overlay d-flex align-items-center justify-content-center py-5">
                <div className="spinner-border text-primary" role="status"></div>
                <span className="ms-3 fw-semibold">Loading technologies...</span>
              </div>
            );
          }
          
           // Error Message
          if (error) {
            return (
              <div className="error-container d-flex flex-column align-items-center justify-content-center py-5">
                <p className="text-danger fs-7">{error}</p>
                <button
                  className="btn btn-outline-primary mt-3"
                  onClick={() => window.location.reload()}
                >
                  Retry
                </button>
              </div>
            );
    }

  return (
    <section className="py-5 bg-light">
      <div className="container">
        <h2 className="fw-bold text-center mb-4">Tech Stack We <span className="text-primary-color">Use</span></h2>
        <p className="text-muted text-center mb-4">
          We use cutting-edge technologies to build scalable and secure digital solutions.
        </p>

        <div
          className="tech-slider d-flex overflow-auto gap-3 px-2 py-2"
          ref={sliderRef}
        >
          {technologies.map((tech, idx) => {
            const IconComponent = SiIcons[tech.iconName] || FaIcons[tech.iconName] || VscIcons[tech.iconName]; // fallback
            return (
            <div
              key={idx}
              className="tech-card flex-shrink-0 bg-white border rounded shadow-sm p-3 text-center"
              style={{ width: 140, minWidth: 140 }}
            >
              <div className="fs-2 text-primary mb-2">{IconComponent && <IconComponent />}</div>
              <small className="fw-semibold">{tech.name}</small>
            </div>
          )})}
        </div>
      </div>
    </section>
  );
};

export default TechStack;
